import styled from 'styled-components';

export const CenterLogo = styled.img`
  margin: auto;
  width: ${(props) => (props.width ? props.width : '212px')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  object-fit: contain;
  display: block;
`;
